import bartoliniLogo from "@Images/bartolini.png";
import colisPriveLogo from "@Images/colis-prive.png";
import colissimoLogo from "@Images/colissimo.png";
import dhlLogo from "@Images/dhl.png";
import laPosteLogo from "@Images/la-poste.png";
import posteItalianeLogo from "@Images/poste-italiane.png";
import royalMailLogo from "@Images/royal-mail.png";
import tipsaLogo from "@Images/tipsa.png";
import tntLogo from "@Images/tnt.png";
import { ImageByLocales } from "@Types/images";

export const deliveryCompagnies: ImageByLocales = {
  en: [
    { name: "DHL", src: dhlLogo },
    { name: "Royal Mail", src: royalMailLogo },
  ],
  es: [
    { name: "DHL", src: dhlLogo },
    { name: "Tipsa", src: tipsaLogo },
  ],
  fr: [
    { name: "Colis Privé", src: colisPriveLogo },
    { name: "Colissimo", src: colissimoLogo },
    { name: "TNT", src: tntLogo },
    { name: "La Poste", src: laPosteLogo },
  ],
  it: [
    { name: "Bartolini", src: bartoliniLogo },
    { name: "DHL", src: dhlLogo },
    { name: "Poste italiane", src: posteItalianeLogo },
  ],
};
